import { useEffect, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import "./App.css";

const App = () => {
    const [scanResult, setScanResult] = useState(null);
    const [errorMessage, setErrorMessage] = useState(""); // Estado para manejar el mensaje de error
    const [scannerKey, setScannerKey] = useState(0); // Estado para forzar el reinicio del escáner

    // Define la variable base según el entorno
    const base = window.location.hostname === "localhost"
        ? "http://127.0.0.1:8000"
        : "https://savethechildrenmx.org";

    useEffect(() => {
        const scanner = new Html5QrcodeScanner("reader", {
            fps: 10,
            qrbox: 250,
        });

        scanner.render(
            (result) => {
                try {
                    playBeep(); // Reproduce el beep
                    const decodedResult = atob(result); // Decodifica el base64
                    const jsonResult = JSON.parse(decodedResult); // Convierte a JSON
                    sendToApi(jsonResult); // Enviar los datos al API
                    scanner.clear(); // Detiene el escaneo
                } catch (error) {
                    console.error("Error al procesar el QR:", error);
                }
            },
            (error) => console.warn(error)
        );

        return () => {
            scanner.clear().catch((err) => console.error(err));
        };
    }, [scannerKey]); // El useEffect depende de 'scannerKey' para reiniciar el escáner

    const playBeep = () => {
        const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        const oscillator = audioCtx.createOscillator();
        const gainNode = audioCtx.createGain();

        oscillator.type = "sine"; // Tipo de sonido
        oscillator.frequency.setValueAtTime(1000, audioCtx.currentTime); // Frecuencia en Hz
        oscillator.connect(gainNode);
        gainNode.connect(audioCtx.destination);

        oscillator.start();
        setTimeout(() => {
            oscillator.stop();
            audioCtx.close();
        }, 150); // Duración del beep (150ms)
    };

    const sendToApi = async (data) => {
        try {
            const queryParams = new URLSearchParams({ id: data.id }).toString();
            const response = await fetch(`${base}/api/events/payment/checkin?${queryParams}`, {
                method: "GET",
            });

            const responseData = await response.json();

            if (responseData.status === 1) {
                setScanResult(responseData.compra); // Almacenar la compra en el estado
                setErrorMessage(""); // Limpiar mensaje de error si la compra es válida
            } else {
                setScanResult(null); // Limpiar resultados de la compra
                setErrorMessage(responseData.message); // Mostrar mensaje de error
            }
        } catch (error) {
            console.error("Error al obtener los datos de la API:", error);
        }
    };

    const handleRestart = () => {
        setScanResult(null); // Reinicia el estado para volver a escanear
        setErrorMessage(""); // Limpiar mensaje de error al reiniciar
        setScannerKey(prevKey => prevKey + 1); // Forzar el reinicio del escáner al cambiar 'scannerKey'
    };

    const extractedData = scanResult ? {
        comprador: scanResult.comprador,
        boletosUsados: scanResult.boletos_usados,
        boletosComprados: scanResult.asientos,
        boletosRestantes: scanResult.asientos - scanResult.boletos_usados,
        mesa: scanResult.event_table.name,
    } : null;

    return (
        <div className="App d-none">
            {errorMessage && (
                <div className="message error-message">
                    <div className="header-message">
                        ERROR
                    </div>
                    <div className="message-resume">
                        <p style={{ color: "red" }}>{errorMessage}</p>
                    </div>
                    <button onClick={handleRestart}>Escanear otro QR</button>
                </div>
            )}

            {extractedData ? (
                <div className="message success-message">
                    <div className="header-message">
                        Resumen del registro
                    </div>
                    <div className="message-resume">
                        <p>Comprador: <br/><b>{extractedData.comprador}</b></p>
                        <p>Mesa: {extractedData.mesa}</p>
                        <p>Boletos Comprados: {extractedData.boletosComprados}</p>
                        <p>Boletos Usados: {extractedData.boletosUsados}</p>
                        <p>Boletos Restantes: {extractedData.boletosRestantes}</p>
                    </div>
                    <button onClick={handleRestart}>Escanear otro QR</button>

                </div>
            ) : (
                <div id="reader" style={{ width: "300px" }}></div>
            )}
        </div>
    );
};

export default App;
